'use client';

import type { ReactNode } from 'react';
import { ValidatedHttpRenderer } from '../../ToolCallsRenderers/renderers/ValidatedHttpRenderer';
import type { OutputRenderContext } from '../../tool-config-types';

export const renderValidatedHttpResult = (
  ctx: OutputRenderContext,
): ReactNode => {
  const { content, maxHeight, onOpenObject } = ctx;
  return (
    <ValidatedHttpRenderer
      data={content}
      maxHeight={maxHeight}
      onOpenObject={onOpenObject}
    />
  );
};
